export const moodPatterns: Record<string, string[]> = {
    'smiley': [
        '  *****  ',
        ' *     * ',
        '*  O O  *',
        '*   ^   *',
        '*  \\_/  *',
        ' *     * ',
        '  *****  '
    ],
    'sad': [
        '  *****  ',
        ' *     * ',
        '*  O O  *',
        '*   v   *',
        '*  ___  *',
        ' *     * ',
        '  *****  '
    ],
    'angry': [
        '  *****  ',
        ' *     * ',
        '*  > <  *',
        '*   ^   *',
        '*  ___  *',
        ' *     * ',
        '  *****  '
    ],
    'surprised': [
        '  *****  ',
        ' *     * ',
        '*  O O  *',
        '*   O   *',
        '*  ___  *',
        ' *     * ',
        '  *****  '
    ],
    'wink': [
        '  *****  ',
        ' *     * ',
        '*  O -  *',
        '*   ^   *',
        '*  \\_/  *',
        ' *     * ',
        '  *****  '
    ],
    'cool': [
        '  *****  ',
        ' *     * ',
        '*  O O  *',
        '*  ---  *',
        '*  \\_/  *',
        ' *  |  * ',
        '  *****  '
    ],
    'sleepy': [
        '  *****  ',
        ' *     * ',
        '*  - -  *',
        '*   v   *',
        '*  ___  *',
        ' *     * ',
        '  *****  '
    ],
    'nerd': [
        '  *****  ',
        ' *     * ',
        '*  O O  *',
        '*  [_]  *',
        '*  \\_/  *',
        ' *  |  * ',
        '  *****  '
    ],
    'robot': [
        '  *****  ',
        ' *     * ',
        '*  [ ]  *',
        '*   -   *',
        '*  [ ]  *',
        ' *     * ',
        '  *****  '
    ],
    'alien': [
        '  *****  ',
        ' *     * ',
        '*  @ @  *',
        '*   ^   *',
        '*  \\_/  *',
        ' *     * ',
        '  *****  '
    ],
    'laughing': [
        '  *****  ',
        ' *     * ',
        '*  ^ ^  *',
        '*   ^   *',
        '* \\___/ *',
        ' *     * ',
        '  *****  '
    ],
    'crying': [
        '  *****  ',
        ' *     * ',
        '*  T T  *',
        '*   v   *',
        '*  ___  *',
        ' *     * ',
        '  *****  '
    ],
    'blushing': [
        '  *****  ',
        ' *     * ',
        '* (O O) *',
        '*   ^   *',
        '*  \\_/  *',
        ' *     * ',
        '  *****  '
    ],
    'shocked': [
        '  *****  ',
        ' *     * ',
        '*  0 0  *',
        '*   O   *',
        '*  ___  *',
        ' *     * ',
        '  *****  '
    ],
    'confused': [
        '  *****  ',
        ' *     * ',
        '*  o O  *',
        '*   ~   *',
        '*  ___  *',
        ' *     * ',
        '  *****  '
    ],
    'love': [
        '  *****  ',
        ' *     * ',
        '*  ❤ ❤  *',
        '*   ^   *',
        '*  \\_/  *',
        ' *     * ',
        '  *****  '
    ],
    'mad': [
        '  *****  ',
        ' *     * ',
        '*  >_<  *',
        '*   ~   *',
        '*  ___  *',
        ' *     * ',
        '  *****  '
    ],
    'bored': [
        '  *****  ',
        ' *     * ',
        '*  - -  *',
        '*   -   *',
        '*  ___  *',
        ' *     * ',
        '  *****  '
    ],
    'thinking': [
        '  *****  ',
        ' *     * ',
        '*  o O  *',
        '*   -   *',
        '*  ~~~  *',
        ' *     * ',
        '  *****  '
    ],
    'surly': [
        '  *****  ',
        ' *     * ',
        '*  -.-  *',
        '*   -   *',
        '*  \\_/  *',
        ' *     * ',
        '  *****  '
    ]
};
